import { cn } from '@app/utils/cn';
import { MovementOffset, useMovement } from '@app/utils/hooks';
import React from 'react';

import { Reposition } from '../Icons';

interface Props {
  isActive?: boolean;
  onStartMovement?: (startPosition: MovementOffset, event: MouseEvent | TouchEvent) => void;
  onMovement: (offset: MovementOffset, event: MouseEvent | TouchEvent) => void;
  onEndMovement?: (offset: MovementOffset, event: MouseEvent | TouchEvent) => void;
  className?: string;
}

export const Mover = React.memo(({ onMovement, onStartMovement, onEndMovement, isActive, className }: Props) => {
  const moveButton = React.useRef<HTMLButtonElement | null>(null);

  useMovement(
    moveButton,
    {
      onEndMovement,
      onMovement,
      onStartMovement,
    },
    isActive,
  );

  return (
    <button
      type="button"
      className={cn(
        'absolute left-0 top-0 z-cmsResizer -translate-x-1/2 -translate-y-1/2 cursor-move rounded-full border-none bg-cmsPink-20 bg-none outline-none',
        className,
      )}
      ref={moveButton}
    >
      <Reposition className="size-4 text-white" />
    </button>
  );
});
